<section style="text-align: center; padding: 40px">
  <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
  <h4>You have been unsubscribed successfully</h4>
</section>
